import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormatBytesPipe } from '@app/shared/pipes/format-bytes.pipe';
import { RejectedFile, RejectedFiles } from '@app/utils/file-checker';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'portal-file-rejected-description',
  templateUrl: './file-rejected-description.component.html',
  styles: [],
  standalone: false,
})
export class FileRejectedDescriptionComponent implements OnChanges {
  /**
   * i18n key that is displayed, if a given file is not accepted because of its type
   */
  @Input()
  acceptDescription?: string;

  @Input()
  clearable: boolean = false;

  @Input()
  multiple: boolean = false;

  @Input()
  noContext: boolean = false;

  @Input()
  rejectedFiles: RejectedFiles;

  @Output()
  clear = new EventEmitter<RejectedFile>();

  i18nPrefix: string = 'common.file.rejected.withReason.';

  constructor(
    private formatBytesPipe: FormatBytesPipe,
    private translateService: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('noContext' in changes) {
      if (changes.noContext.currentValue) {
        this.i18nPrefix = 'common.file.rejected.';
      } else {
        this.i18nPrefix = 'common.file.rejected.withReason';
      }
    }
  }

  translateContext(rejectedFile: RejectedFile) {
    const context: Record<string, any> = {
      name: rejectedFile.file.name,
    };

    if (rejectedFile.reason === 'maxFileSize') {
      context.maxFileSize = this.formatBytesPipe.transform(this.rejectedFiles.maxFileSize!);
      context.rejectedFileSize = this.formatBytesPipe.transform(rejectedFile.file.size!);
    } else if (rejectedFile.reason === 'accept') {
      if (this.acceptDescription != null) {
        context.accept = this.translateService.instant(this.acceptDescription);
      } else {
        context.accept = this.rejectedFiles.accept;
      }
    }

    return context;
  }
}
